
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/link-demo/bank_income",
      function () {
        return require("private-next-pages/link-demo/bank_income.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/link-demo/bank_income"])
      });
    }
  